import { isDevelopment } from '$lib/utils/environmentResolver';

export const getAlidaDomain = (pod: string) => {
	if (isDevelopment(pod)) {
		return `alidalabs` as const;
	}
	return `alida` as const;
};
